const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export interface GenerateCADResponse {
  status: string;
  scad_code: string;
}

export async function generateCAD(prompt: string): Promise<GenerateCADResponse> {
  const response = await fetch(`${API_BASE_URL}/api/generate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ prompt }),
  });

  if (response.status === 429) {
    throw new Error("Generation limit reached (5 CADs/hour). Please wait.");
  }

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || "Failed to generate CAD model.");
  }

  return response.json();
}

// Fetches the STL blob to display in the 3D Viewer
export async function getStlPreviewUrl(scadCode: string): Promise<string> {
  const response = await fetch(`${API_BASE_URL}/api/download/stl`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ scad_code: scadCode }),
  });

  if (!response.ok) throw new Error("Failed to render 3D preview.");
  
  const blob = await response.blob();
  return window.URL.createObjectURL(blob);
}

// Triggers a browser download for the selected format
export async function downloadCADFile(scadCode: string, format: "stl" | "3mf" | "scad"): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/api/download/${format}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ scad_code: scadCode }),
  });

  if (!response.ok) throw new Error(`Failed to export ${format.toUpperCase()}`);

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `model.${format}`;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}